import { useMemo } from 'react';
import * as React from 'react';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import Column from '@sdk/components/ui/spacing/Column';
import StatusLabel from '@sdk/components/ui/StatusLabel';
import type { IntegrationType } from '@sdk/integrations/types';

import { getStatusLabel, getStatusLabelType } from '../helpers/utils';

type Props = {
  integration: IntegrationType;
};

const IntegrationStatusLabel: React.FC<React.PropsWithChildren<Props>> = ({ integration }) => {
  const externalSlug = useMemo(
    () => integration.parameters.find((param) => param.name === 'external_slug'),
    [integration.parameters]
  );

  const tooltipContent = externalSlug ? externalSlug.value + externalSlug.postfix : null;

  return (
    <>
      <Column data-place="top" data-tip={tooltipContent} data-tip-disable={!tooltipContent}>
        <StatusLabel label={getStatusLabel(integration)} type={getStatusLabelType(integration)} />
      </Column>
      <Tooltip />
    </>
  );
};

export default IntegrationStatusLabel;
